import { transformError as sdkTransformError } from '@wix/sdk-runtime/transform-error';
import { renameKeysFromSDKRequestToRESTRequest, renameKeysFromRESTResponseToSDKResponse, } from '@wix/sdk-runtime/rename-all-nested-keys';
import * as ambassadorWixBookingsV2Booking from './bookings-v2-booking-bookings.http';
export var MultiServiceBookingType;
(function (MultiServiceBookingType) {
    /**
     * Multi service booking will be considered available if its bookings are
     * available as returned from ListMultiServiceAvailabilityTimeSlots API.
     * See [List Multi Service Availability Time Slots] (url) documentation // todo: complete url
     */
    MultiServiceBookingType["SEQUENTIAL_BOOKINGS"] = "SEQUENTIAL_BOOKINGS";
    /**
     * Multi service booking will be considered available if each of its bookings is available separately.
     * Not supported yet
     */
    MultiServiceBookingType["SEPARATE_BOOKINGS"] = "SEPARATE_BOOKINGS";
    /** Not supported yet */
    MultiServiceBookingType["PARALLEL_BOOKINGS"] = "PARALLEL_BOOKINGS";
})(MultiServiceBookingType || (MultiServiceBookingType = {}));
export var LocationType;
(function (LocationType) {
    LocationType["UNDEFINED"] = "UNDEFINED";
    LocationType["OWNER_BUSINESS"] = "OWNER_BUSINESS";
    LocationType["OWNER_CUSTOM"] = "OWNER_CUSTOM";
    LocationType["CUSTOM"] = "CUSTOM";
})(LocationType || (LocationType = {}));
export var ValueType;
(function (ValueType) {
    /** Short text. This is the default value type. */
    ValueType["SHORT_TEXT"] = "SHORT_TEXT";
    /** Long text */
    ValueType["LONG_TEXT"] = "LONG_TEXT";
    /** a text that represent the check box value: if selected the value is "true", otherwise "false". */
    ValueType["CHECK_BOX"] = "CHECK_BOX";
})(ValueType || (ValueType = {}));
/** Booking status. */
export var BookingStatus;
(function (BookingStatus) {
    BookingStatus["CREATED"] = "CREATED";
    BookingStatus["CONFIRMED"] = "CONFIRMED";
    BookingStatus["CANCELED"] = "CANCELED";
    BookingStatus["PENDING"] = "PENDING";
    BookingStatus["DECLINED"] = "DECLINED";
    BookingStatus["WAITING_LIST"] = "WAITING_LIST";
})(BookingStatus || (BookingStatus = {}));
/**
 * Payment status.
 * Automatically updated when using eCom checkout APIs.
 */
export var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["UNDEFINED"] = "UNDEFINED";
    PaymentStatus["NOT_PAID"] = "NOT_PAID";
    PaymentStatus["PAID"] = "PAID";
    /** not supported yet. */
    PaymentStatus["PARTIALLY_PAID"] = "PARTIALLY_PAID";
    /** not supported yet */
    PaymentStatus["REFUNDED"] = "REFUNDED";
    PaymentStatus["EXEMPT"] = "EXEMPT";
})(PaymentStatus || (PaymentStatus = {}));
/**
 * The selected payment option.
 * One of the payment options offered by the service.
 * This field is be set when the user selects an option during booking.
 * If left undefined, the payment option is resolved by the service configuration on checkout.
 */
export var SelectedPaymentOption;
(function (SelectedPaymentOption) {
    SelectedPaymentOption["UNDEFINED"] = "UNDEFINED";
    SelectedPaymentOption["OFFLINE"] = "OFFLINE";
    SelectedPaymentOption["ONLINE"] = "ONLINE";
    SelectedPaymentOption["MEMBERSHIP"] = "MEMBERSHIP";
    /** Payment can only be done using a membership and must be manually redeemed in the dashboard by the site owner. */
    SelectedPaymentOption["MEMBERSHIP_OFFLINE"] = "MEMBERSHIP_OFFLINE";
})(SelectedPaymentOption || (SelectedPaymentOption = {}));
export var Platform;
(function (Platform) {
    Platform["UNDEFINED_PLATFORM"] = "UNDEFINED_PLATFORM";
    Platform["WEB"] = "WEB";
    Platform["MOBILE_APP"] = "MOBILE_APP";
})(Platform || (Platform = {}));
export var Actor;
(function (Actor) {
    Actor["UNDEFINED_ACTOR"] = "UNDEFINED_ACTOR";
    Actor["BUSINESS"] = "BUSINESS";
    Actor["CUSTOMER"] = "CUSTOMER";
})(Actor || (Actor = {}));
export var IdentificationDataIdentityType;
(function (IdentificationDataIdentityType) {
    IdentificationDataIdentityType["UNKNOWN"] = "UNKNOWN";
    IdentificationDataIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    IdentificationDataIdentityType["MEMBER"] = "MEMBER";
    IdentificationDataIdentityType["WIX_USER"] = "WIX_USER";
    IdentificationDataIdentityType["APP"] = "APP";
})(IdentificationDataIdentityType || (IdentificationDataIdentityType = {}));
export var LocationLocationType;
(function (LocationLocationType) {
    LocationLocationType["UNDEFINED"] = "UNDEFINED";
    LocationLocationType["OWNER_BUSINESS"] = "OWNER_BUSINESS";
    LocationLocationType["OWNER_CUSTOM"] = "OWNER_CUSTOM";
    LocationLocationType["CUSTOM"] = "CUSTOM";
})(LocationLocationType || (LocationLocationType = {}));
export var IdentityType;
(function (IdentityType) {
    IdentityType["UNKNOWN"] = "UNKNOWN";
    IdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    IdentityType["MEMBER"] = "MEMBER";
    IdentityType["WIX_USER"] = "WIX_USER";
    IdentityType["APP"] = "APP";
})(IdentityType || (IdentityType = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
/**
 * Creates a booking.
 *
 *
 * To create a booking for an appointment or a session of a class, pass a booking with the relevant `slot`.
 *
 * To create a booking for the entire course, pass a booking with the relevant `schedule`.
 * You can use Query Availability to check the availability beforehand.
 *
 * If you create a booking for an existing session, we recommend that you only pass `slot.sessionId`.
 * Then, any specified slot details are calculated.
 *
 * If you create a booking for a new session, we recommend to call Query Availability first.
 * Then, pass the retrieved `availability.slot` object as the BookedEntity.Slot of the booking in the request.
 *
 * Bookings are created with a status of `CREATED`.
 * `CREATED` bookings don't appear on the business calendar and don't affect a related schedule's availability.
 *
 * To create a booking with a given status, pass a booking with the wanted status.
 * This is only permitted for site Owners.
 *
 * You can pass a `participantNotification.message` to notify the customer of the booking with a message.
 * It's also necessary to pass `participantNotification.notifyParticipants`as `true` to send the message.
 *
 * You can pass `sendSmsReminder` as `true`, if you want an SMS reminder to be sent to the phone number specified in the ContactDetails, 24 hours before the session starts.
 *
 * When creating a booking you must pass either `participantsChoices` or `totalParticipants`. If you pass `participantsChoices`, all the
 * provided choices must exist for the service, otherwise the call returns an `INVALID_SERVICE_CHOICES` error.
 *
 * When creating a booking, you can pass `selectedPaymentOption`.
 * This specifies which payment method the customer plans to use.
 * But it's possible for them to later use another supported payment method.
 *
 * You can skip the checkout and payment flow if you call Confirm Or Decline Booking otherwise, after you create the booking, you can use the
 * Wix eCommerce APIs (coming soon) for the checkout and payment flow or use a different service for checkout.
 * @param booking - The booking to create.
 * @public
 * @documentationMaturity preview
 * @requiredField booking
 * @requiredField booking.additionalFields._id
 * @requiredField booking.bookedEntity
 * @permissionId BOOKINGS.BOOKING_CREATE
 * @permissionScope Manage Bookings
 * @permissionScopeId SCOPE.DC-BOOKINGS.MANAGE-BOOKINGS
 * @permissionScope Manage Bookings - all permissions
 * @permissionScopeId SCOPE.DC-BOOKINGS-MEGA.MANAGE-BOOKINGS
 * @applicableIdentity APP
 * @applicableIdentity VISITOR
 */
export async function createBooking(booking, options) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[2];
    const payload = renameKeysFromSDKRequestToRESTRequest({
        booking: booking,
        participantNotification: options?.participantNotification,
        sendSmsReminder: options?.sendSmsReminder,
        flowControlSettings: options?.flowControlSettings,
    });
    const reqOpts = ambassadorWixBookingsV2Booking.createBooking(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
        return renameKeysFromRESTResponseToSDKResponse(result.data);
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: {},
            explicitPathsToArguments: {
                booking: '$[0]',
                participantNotification: '$[1].participantNotification',
                sendSmsReminder: '$[1].sendSmsReminder',
                flowControlSettings: '$[1].flowControlSettings',
            },
            singleArgumentUnchanged: false,
        }, ['booking', 'options']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
/**
 * Creates multiple bookings.
 *
 *
 * See [`createBooking()`](https://www.wix.com/velo/reference/wix-bookings-v2/bookings/createbooking) documentation.
 *
 * If for any of the bookings required fields were not passed on the request or if the caller doesn't have the required permissions to create such booking, the call will fail.
 * If the request contains unavailable bookings, the call will be completed successfully, but the unavailable bookings will not be created and will be considered as a failure on the response.
 * @param createBookingsInfo - Bookings to create.
 * Max: 8 bookings.
 * @public
 * @documentationMaturity preview
 * @requiredField createBookingsInfo
 * @requiredField createBookingsInfo.booking
 * @requiredField createBookingsInfo.booking.additionalFields._id
 * @requiredField createBookingsInfo.booking.bookedEntity
 * @permissionId BOOKINGS.BOOKING_CREATE
 * @permissionScope Manage Bookings
 * @permissionScopeId SCOPE.DC-BOOKINGS.MANAGE-BOOKINGS
 * @permissionScope Manage Bookings - all permissions
 * @permissionScopeId SCOPE.DC-BOOKINGS-MEGA.MANAGE-BOOKINGS
 * @applicableIdentity APP
 * @applicableIdentity VISITOR
 */
export async function bulkCreateBooking(createBookingsInfo, options) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[2];
    const payload = renameKeysFromSDKRequestToRESTRequest({
        createBookingsInfo: createBookingsInfo,
        returnFullEntity: options?.returnFullEntity,
    });
    const reqOpts = ambassadorWixBookingsV2Booking.bulkCreateBooking(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
        return renameKeysFromRESTResponseToSDKResponse(result.data);
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: {},
            explicitPathsToArguments: {
                createBookingsInfo: '$[0]',
                returnFullEntity: '$[1].returnFullEntity',
            },
            singleArgumentUnchanged: false,
        }, ['createBookingsInfo', 'options']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
/**
 * Reschedules a booking to a different slot or session.
 *
 *
 * You can only reschedule bookings for appointments or classes, you can't
 * reschedule course bookings.
 *
 * The old session is removed from the calendar and the new session is
 * added.
 *
 * If you reschedule a booking for a class session the new session must be an
 * existing session for the same class.
 *
 * You can pass a `participantNotification.message` to notify the customer of
 * the rescheduling. You also need to pass `participantNotification.notifyParticipants`
 * as `true` to actually send the message.
 *
 * In case the service has
 * variants, you can call this endpoint to update the booking's `totalParticipants` or `participantsChoices`.
 * If you provide `participantsChoices`, all of the provided choices must exist for
 * the service. Otherwise, the call returns an `INVALID_SERVICE_CHOICES` error.
 * If you omit `participantsChoices` in the request, the existing choices are
 * kept and not replaced with an empty object.
 *
 * <!-- INTERNAL PERMISSION COMMENT:
 * You need to have the `BOOKINGS.NUMBER_OF_PARTICIPANTS_UPDATE` permission
 * to reschedule bookings including `participantsInfo`.
 * <!--END: INTERNAL PERMISSION COMMENT-->
 *
 * In case you want to reschedule a booking on behalf of a customer, we recommend
 * to pass `flowControlSettings.ignoreReschedulePolicy` as `false`. This
 * ensures that the rescheduling is validated against the service's rescheduling
 * policy.
 * @param bookingId - ID of the booking to reschedule.
 * @param slot - Information about the new slot.
 * @public
 * @documentationMaturity preview
 * @requiredField bookingId
 * @requiredField options.revision
 * @requiredField slot
 * @param options - An object representing the available options for rescheduling a booking.
 * @permissionId BOOKINGS.BOOKING_RESCHEDULE
 * @permissionScope Manage Bookings
 * @permissionScopeId SCOPE.DC-BOOKINGS.MANAGE-BOOKINGS
 * @permissionScope Manage Bookings - all permissions
 * @permissionScopeId SCOPE.DC-BOOKINGS-MEGA.MANAGE-BOOKINGS
 * @applicableIdentity APP
 * @applicableIdentity MEMBER
 */
export async function rescheduleBooking(bookingId, slot, options) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[3];
    const payload = renameKeysFromSDKRequestToRESTRequest({
        bookingId: bookingId,
        slot: slot,
        revision: options?.revision,
        participantNotification: options?.participantNotification,
        flowControlSettings: options?.flowControlSettings,
        totalParticipants: options?.totalParticipants,
        participantsChoices: options?.participantsChoices,
    });
    const reqOpts = ambassadorWixBookingsV2Booking.rescheduleBooking(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
        return renameKeysFromRESTResponseToSDKResponse(result.data);
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: {},
            explicitPathsToArguments: {
                bookingId: '$[0]',
                slot: '$[1]',
                revision: '$[2].revision',
                participantNotification: '$[2].participantNotification',
                flowControlSettings: '$[2].flowControlSettings',
                totalParticipants: '$[2].totalParticipants',
                participantsChoices: '$[2].participantsChoices',
            },
            singleArgumentUnchanged: false,
        }, ['bookingId', 'slot', 'options']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
/**
 * Confirms a booking request and changes the booking status to `CONFIRMED`.
 *
 *
 * Calling this method doesn't check whether a slot or schedule is still
 * available at this time.
 *
 * You can only confirm bookings for services that require the owner's manual
 * approval for bookings and that have a status of `PENDING`.
 *
 * For appointment services the slot may become unavailable, depending on the
 * [service's](https://support.wix.com/en/article/creating-the-right-booking-service-for-your-business)
 * `policy.bookingApprovalPolicy.requestsAffectsAvailability`.
 *
 * Calling this method also changes the
 * [session's](https://www.wix.com/velo/reference/wix-bookings-backend/sessions/getsession)
 * `participants.approvalStatus` to `APPROVED`.
 *
 * You can pass a `participantNotification.message` to notify the customer of
 * the confirmation. You also need to pass `participantNotification.notifyParticipants`
 * as `true` to actually send the message.
 *
 * Bookings are automatically confirmed when the
 * service is configured to automatically confirm
 * bookings and the [eCommerce order](https://www.wix.com/velo/reference/wix-ecom-backend/orders)
 * has been approved. The slot's or schedule's availability is checked just
 * before confirming the booking as part of the automatic flow.
 * @param bookingId - ID of the booking to confirm.
 * @param revision - Revision number, which increments by 1 each time the booking is updated.
 * To prevent conflicting changes, the current revision must be passed when
 * managing the booking.
 * @public
 * @documentationMaturity preview
 * @requiredField bookingId
 * @requiredField revision
 * @param options - An object representing the available options for canceling a booking.
 * @permissionId BOOKINGS.BOOKING_CONFIRM
 * @permissionScope Manage Bookings
 * @permissionScopeId SCOPE.DC-BOOKINGS.MANAGE-BOOKINGS
 * @permissionScope Manage Bookings - all permissions
 * @permissionScopeId SCOPE.DC-BOOKINGS-MEGA.MANAGE-BOOKINGS
 * @applicableIdentity APP
 */
export async function confirmBooking(bookingId, revision, options) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[3];
    const payload = renameKeysFromSDKRequestToRESTRequest({
        bookingId: bookingId,
        revision: revision,
        participantNotification: options?.participantNotification,
        sendSmsReminder: options?.sendSmsReminder,
        paymentStatus: options?.paymentStatus,
        doubleBooked: options?.doubleBooked,
        flowControlSettings: options?.flowControlSettings,
    });
    const reqOpts = ambassadorWixBookingsV2Booking.bookingsConfirmBooking(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
        return renameKeysFromRESTResponseToSDKResponse(result.data);
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: {},
            explicitPathsToArguments: {
                bookingId: '$[0]',
                revision: '$[1]',
                participantNotification: '$[2].participantNotification',
                sendSmsReminder: '$[2].sendSmsReminder',
                paymentStatus: '$[2].paymentStatus',
                doubleBooked: '$[2].doubleBooked',
                flowControlSettings: '$[2].flowControlSettings',
            },
            singleArgumentUnchanged: false,
        }, ['bookingId', 'revision', 'options']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
/**
 * Updates the extended fields for a booking.
 *
 *
 * Extended fields must first be configured in the [Wix Developers Center](https://dev.wix.com/app-selector?title=Select+an+App&primaryButtonText=Select+Site&actionUrl=https%3A%2F%2Fdev.wix.com%2Fapps%2F%7BappId%7D%2Fextensions).
 *
 * Learn more about setting up extended fields with [schema plugins](https://dev.wix.com/docs/build-apps/develop-your-app/extensions/backend-extensions/schema-plugins/about-schema-plugin-extensions).
 * @public
 * @documentationMaturity preview
 * @requiredField _id
 * @requiredField namespace
 * @requiredField options
 * @requiredField options.namespaceData
 * @param _id - ID of the booking for which to update extended fields.
 * @param namespace - [Namespace](https://dev.wix.com/docs/build-apps/develop-your-app/extensions/backend-extensions/schema-plugins/about-reading-and-writing-schema-plugin-fields#namespaces) of the app for which to update extended fields.
 * @param options - Options for updating the booking's extended fields.
 * @permissionId BOOKINGS.BOOKING_UPDATE_EXTENDED_FIELDS
 * @permissionScope Manage Bookings
 * @permissionScopeId SCOPE.DC-BOOKINGS.MANAGE-BOOKINGS
 * @permissionScope Manage Bookings - all permissions
 * @permissionScopeId SCOPE.DC-BOOKINGS-MEGA.MANAGE-BOOKINGS
 * @applicableIdentity APP
 */
export async function updateExtendedFields(_id, namespace, options) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[3];
    const payload = renameKeysFromSDKRequestToRESTRequest({
        id: _id,
        namespace: namespace,
        namespaceData: options?.namespaceData,
    });
    const reqOpts = ambassadorWixBookingsV2Booking.updateExtendedFields(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
        return renameKeysFromRESTResponseToSDKResponse(result.data);
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: {},
            explicitPathsToArguments: {
                id: '$[0]',
                namespace: '$[1]',
                namespaceData: '$[2].namespaceData',
            },
            singleArgumentUnchanged: false,
        }, ['_id', 'namespace', 'options']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
/**
 * Declines a `PENDING` booking request and changes the booking status to
 * `DECLINED`.
 *
 * Calling this method also changes the
 * [session's](https://www.wix.com/velo/reference/wix-bookings-backend/sessions/getsession)
 * `participants.approvalStatus` to `DECLINED`.
 *
 * You can only decline bookings for services that require the owner's manual
 * approval for bookings and that have a status of `PENDING`.
 *
 * You can pass a `participantNotification.message` to notify the customer of
 * the decline. You also need to pass `participantNotification.notifyParticipants`
 * as `true` to actually send the message.
 * @param bookingId - ID of the booking to decline.
 * @param revision - Revision number, which increments by 1 each time the booking is updated.
 * To prevent conflicting changes, the current revision must be passed when
 * managing the booking.
 * @public
 * @documentationMaturity preview
 * @requiredField bookingId
 * @requiredField revision
 * @param options - An object representing the available options for declining a booking.
 * @permissionId BOOKINGS.BOOKING_DECLINE
 * @permissionScope Manage Bookings
 * @permissionScopeId SCOPE.DC-BOOKINGS.MANAGE-BOOKINGS
 * @permissionScope Manage Bookings - all permissions
 * @permissionScopeId SCOPE.DC-BOOKINGS-MEGA.MANAGE-BOOKINGS
 * @applicableIdentity APP
 */
export async function declineBooking(bookingId, revision, options) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[3];
    const payload = renameKeysFromSDKRequestToRESTRequest({
        bookingId: bookingId,
        revision: revision,
        participantNotification: options?.participantNotification,
        paymentStatus: options?.paymentStatus,
        doubleBooked: options?.doubleBooked,
    });
    const reqOpts = ambassadorWixBookingsV2Booking.bookingsDeclineBooking(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
        return renameKeysFromRESTResponseToSDKResponse(result.data);
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: {},
            explicitPathsToArguments: {
                bookingId: '$[0]',
                revision: '$[1]',
                participantNotification: '$[2].participantNotification',
                paymentStatus: '$[2].paymentStatus',
                doubleBooked: '$[2].doubleBooked',
            },
            singleArgumentUnchanged: false,
        }, ['bookingId', 'revision', 'options']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
/**
 * Cancels a booking.
 *
 *
 * The booking status changes to `CANCELED`.
 *
 * If the booking was for an appointment, the corresponding session is
 * deleted from the business calendar.
 *
 * If the booking was for a class or course, the participants are removed
 * from the class session or the course. But the course or class session
 * remains on the business calendar.
 *
 * You can pass a `participantNotification.message` to notify the customer of
 * the cancelation. You also need to pass `participantNotification.notifyParticipants`
 * as `true` to actually send the message.
 *
 * In case you want to cancel a booking on behalf of a customer, we recommend
 * to pass `flowControlSettings.ignoreCancellationPolicy` as `false`. This
 * ensures that the cancelation is validated against the service's cancelation
 * policy.
 * @param bookingId - ID of the booking to cancel.
 * @public
 * @documentationMaturity preview
 * @requiredField bookingId
 * @requiredField options.revision
 * @param options - An object representing the available options for canceling a booking.
 * @permissionId BOOKINGS.BOOKING_CANCEL
 * @permissionScope Manage Bookings
 * @permissionScopeId SCOPE.DC-BOOKINGS.MANAGE-BOOKINGS
 * @permissionScope Manage Bookings - all permissions
 * @permissionScopeId SCOPE.DC-BOOKINGS-MEGA.MANAGE-BOOKINGS
 * @applicableIdentity APP
 * @applicableIdentity MEMBER
 */
export async function cancelBooking(bookingId, options) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[2];
    const payload = renameKeysFromSDKRequestToRESTRequest({
        bookingId: bookingId,
        participantNotification: options?.participantNotification,
        flowControlSettings: options?.flowControlSettings,
        revision: options?.revision,
    });
    const reqOpts = ambassadorWixBookingsV2Booking.bookingsCancelBooking(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
        return renameKeysFromRESTResponseToSDKResponse(result.data);
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: {},
            explicitPathsToArguments: {
                bookingId: '$[0]',
                participantNotification: '$[1].participantNotification',
                flowControlSettings: '$[1].flowControlSettings',
                revision: '$[1].revision',
            },
            singleArgumentUnchanged: false,
        }, ['bookingId', 'options']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
/**
 * Updates the number of participants for a booking.
 *
 *
 * You can only update the number of participants for class and course
 * bookings, you can't update it for appointment bookings.
 *
 * Calling this method also changes the
 * [session's](https://www.wix.com/velo/reference/wix-bookings-backend/sessions/getsession)
 * `totalNumberOfParticipants`.
 *
 * When updating the number of participants for a booking you must pass either
 * `participantsChoices` or `totalParticipants`. If you pass `participantsChoices`
 * for services that have variants,
 * all of the provided choices must exist for the service. Otherwise, the
 * call returns an `INVALID_SERVICE_CHOICES` error.
 * @param bookingId - ID of the booking to update the number of participants for.
 * @public
 * @documentationMaturity preview
 * @requiredField bookingId
 * @requiredField options.revision
 * @permissionId BOOKINGS.NUMBER_OF_PARTICIPANTS_UPDATE
 * @permissionScope Manage Bookings
 * @permissionScopeId SCOPE.DC-BOOKINGS.MANAGE-BOOKINGS
 * @permissionScope Manage Bookings - all permissions
 * @permissionScopeId SCOPE.DC-BOOKINGS-MEGA.MANAGE-BOOKINGS
 * @applicableIdentity APP
 */
export async function updateNumberOfParticipants(bookingId, options) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[2];
    const payload = renameKeysFromSDKRequestToRESTRequest({
        bookingId: bookingId,
        revision: options?.revision,
        totalParticipants: options?.totalParticipants,
        participantsChoices: options?.participantsChoices,
    });
    const reqOpts = ambassadorWixBookingsV2Booking.bookingsUpdateNumberOfParticipants(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
        return renameKeysFromRESTResponseToSDKResponse(result.data);
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: {},
            explicitPathsToArguments: {
                bookingId: '$[0]',
                revision: '$[1].revision',
                totalParticipants: '$[1].totalParticipants',
                participantsChoices: '$[1].participantsChoices',
            },
            singleArgumentUnchanged: false,
        }, ['bookingId', 'options']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
/**
 * Use `confirmOrDeclineBooking()` to determine if the booking is valid, payment is received, and the booking can be processed.
 * Call `confirmOrDeclineBooking()` after checkout or after calling `createBooking()` to verify the booking.
 *
 * + If a session is valid and payment is received, the booking is visible on the calendar.
 * + If a session is double booked, `confirmOrDeclineBooking()` can catch this and decline the duplicate booking, the booking is not visible on the calendar.
 * @param bookingId - ID of the booking to confirm or decline.
 * @public
 * @documentationMaturity preview
 * @requiredField bookingId
 * @permissionId BOOKINGS.BOOKING_CONFIRM_OR_DECLINE
 * @permissionScope Manage Bookings
 * @permissionScopeId SCOPE.DC-BOOKINGS.MANAGE-BOOKINGS
 * @permissionScope Manage Bookings - all permissions
 * @permissionScopeId SCOPE.DC-BOOKINGS-MEGA.MANAGE-BOOKINGS
 * @applicableIdentity APP
 */
export async function confirmOrDeclineBooking(bookingId, options) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[2];
    const payload = renameKeysFromSDKRequestToRESTRequest({
        bookingId: bookingId,
        paymentStatus: options?.paymentStatus,
    });
    const reqOpts = ambassadorWixBookingsV2Booking.confirmOrDeclineBooking(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
        return renameKeysFromRESTResponseToSDKResponse(result.data);
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: {},
            explicitPathsToArguments: {
                bookingId: '$[0]',
                paymentStatus: '$[1].paymentStatus',
            },
            singleArgumentUnchanged: false,
        }, ['bookingId', 'options']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
//# sourceMappingURL=bookings-v2-booking-bookings.universal.js.map